export const getErrorMessageByKey = (errorTag: string): string => {
  switch (errorTag) {
    case 'AmountCollectedExceedsNorm':
      return 'Собранное количество превышает норму'
    case 'duplicateRegistryNumber':
      return 'Дубликат реестрового номера'
    default:
      return 'Внутренняя ошибка сервиса'
  }
}

export const isErrorMessageByKey = (errorTag: string): boolean => {
  switch (errorTag) {
    default:
      return true
  }
}

interface IError {
  response: {
    data: {
      error: string
    }
  }
  request: {
    status: number
  }
}
export type Error = IError
